import React, { useState } from "react";
import { toast } from "react-toastify";
import Axios from "../../config/AxiosConfig";
import { Eye, EyeSlash } from "react-bootstrap-icons";

const ChangePasswordModal = ({ onClose }) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false)
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match!", { position: "top-right" });
      return;
    }

    setLoading(true);

    try {
      await Axios.post("super-admin/change-password", {
        oldPassword,
        newPassword,
      });

      toast.success("Password updated successfully!", {
        position: "top-right",
      });
      setTimeout(() => onClose(), 1000);
    } catch (err) {
      toast.error(err.response?.data?.message || "Error updating password!", {
        position: "top-right",
      });
    }

    setLoading(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h3>Change Password</h3>
        <form onSubmit={handleChangePassword}>
          <div className="mb-3">
            <label className="form-label">Old Password</label>
            <div className="input-group">
              <input
                type={passwordVisible ? "text" : "password"}
                className="form-control"
                placeholder="Enter old password"
                required
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
              <span
                className="input-group-text"
                onClick={() => setPasswordVisible(!passwordVisible)}
                style={{ cursor: "pointer" }}
              >
                {passwordVisible ? <EyeSlash /> : <Eye />}
              </span>
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label">New Password</label>
            <div className="input-group">
              <input
                type={newPasswordVisible ? "text" : "password"}
                className="form-control"
                placeholder="Enter new password"
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <span
                className="input-group-text"
                onClick={() => setNewPasswordVisible(!newPasswordVisible)}
                style={{ cursor: "pointer" }}
              >
                {newPasswordVisible ? <EyeSlash /> : <Eye />}
              </span>
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label">Confirm Password</label>
            <div className="input-group">
              <input
                type={confirmPasswordVisible ? "text" : "password"}
                className="form-control"
                placeholder="Confirm new password"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <span
                className="input-group-text"
                onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
                style={{ cursor: "pointer" }}
              >
                {confirmPasswordVisible ? <EyeSlash /> : <Eye />}
              </span>
            </div>
          </div>
          <button
            type="submit"
            className="btn btn-success w-100"
            disabled={loading}
          >
            {loading ? "Updating..." : "Change Password"}
          </button>
        </form>
        <button onClick={onClose} className="btn btn-secondary mt-3">
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
